<template>
<div id="pwchange-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="pwchange-modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="pwchange-modalLabel">비밀번호 변경</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3" v-for="field in fields" :key="field.id">
                    <label :for="field.id" class="form-label">
                        {{ field.label }} <span class="text-danger">*</span>
                    </label>
                    <div class="input-group input-group-merge">
                        <input :type="changeInputType(field.view)" :id="field.id" class="form-control" :placeholder="field.placeholder" maxlength="16" v-model="field.model" @blur="targetCheckPw(field)">
                        <div class="input-group-text" @click="field.view = !field.view">
                            <i class="mdi" :class="changePwIcon(field.view)"></i>
                        </div>
                        <div class="invalid-feedback">
                            {{ errMsg[field.id] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="changePw()">변경</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import common from "@/mixins/common.js";
import validation from "@/mixins/validation.js";

export default {
    props: ["errMsg"],
    mixins: [common, validation],
    data() {
        return {
            fields: [{
                    id: "current_password",
                    label: "현재 비밀번호",
                    placeholder: "현재 비밀번호를 입력해주세요.",
                    model: "",
                    view: false,
                },
                {
                    id: "new_password",
                    label: "새 비밀번호",
                    placeholder: "새 비밀번호를 입력해주세요.",
                    model: "",
                    view: false,
                },
                {
                    id: "new_password_confirm",
                    label: "새 비밀번호 확인",
                    placeholder: "새 비밀번호 확인",
                    model: "",
                    view: false,
                }
            ]
        }
    },
    async mounted() {
        $("#pwchange-modal").on("hidden.bs.modal", () => {
            this.fields.forEach(field => {
                field.view = false;
                field.model = "";
                $(`#${field.id}`).removeClass("is-invalid");
            });
        });
    },
    methods: {
        changePw() {
            const pass = this.fields.map(field => this.targetCheckPw(field)).filter(i => !i);

            if (pass.length <= 0) {
                const payload = {};

                this.fields.forEach(field => {
                    payload[field.id] = field.model;
                });

                this.axios.post("/changePw", payload).then(async () => {
                    alert("비밀번호 변경이 정상적으로 완료되었습니다.\n확인 버튼 클릭 시, 로그인 페이지로 이동합니다.");
                    await this.$store.dispatch("logout");
                }).catch(err => {
                    console.log(err);
                    alert("현재 비밀번호가 일치하지 않거나 새로운 비밀번호가 서로 다릅니다.\n다시 시도해주세요.");
                });
            }
        }
    }
}
</script>
